<div class="content-wrapper container-xxl p-0">
    <div class="card">
        <div class="row ">
          <!-- First Column - Show -->
          <div class="col-md-6 col-12 d-flex align-items-center">
            <label class="d-flex align-items-center m-1 w-15">
              <div
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
              >
                Show :
              </div>
            </label>
            <label class="d-flex align-items-center m-1 w-50">
              <select
                class="form-control mx-25 w-50"
                [(ngModel)]="selectedOption"
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>

          <!-- Third Column - Search -->
          <div
            class="col-md-6 col-12 d-flex justify-content-end align-items-center"
          >
            <label class="d-flex align-items-center m-1 w-100">
              <label class="d-flex align-items-center m-1 w-15">
                <div
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
                >
                  Search
                </div>
              </label>

              <div class="input-group">
                <input
                  #searchInput
                  type="text"
                  class="form-control"
                  (keyup)="filterUpdate($event)"
                  (search)="filterUpdate($event)"
                  placeholder="{{
                    'MENU.DASHBOARD.SEARCH' | translate
                  }}"
                />
                <div class="input-group-append">
                  <button
                    class="btn btnn"
                    type="button"
                    (click)="filterUpdate($event, true)"
                  >
                    <i class="fa fa-search"></i>
                    <!-- FontAwesome search icon -->
                  </button>
                </div>
              </div>
            </label>
          </div>
        </div>
        <ngx-datatable
          [rows]="userDataPending"
          [rowHeight]="78"
          class="bootstrap core-bootstrap bg-white"
          [limit]="pageSizePending"
          [headerHeight]="60"
          [footerHeight]="38"
          [columnMode]="'force'"
          [count]="totalRecordsPending"
          [offset]="pagePending - 1"
          [externalPaging]="true"
          (page)="onPageChangePending($event)"
          [scrollbarH]="true"
        >
          <!-- ID -->
          <ngx-datatable-column name="ID" prop="id" [flexGrow]="5">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <small
                  class="font-small-3 font-weight-bold line-height-1 mb-25"
                  >{{ row.id }}</small
                >
              </div>
            </ng-template>
          </ngx-datatable-column>

          <!-- Image -->
          <ngx-datatable-column
            name="Image"
            prop="image"
            [flexGrow]="5"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <img
                  [src]="getFirstImage(row)"
                  alt="Image"
                  class="avatar"
                  width="50"
                  height="50"
                  style="max-height: 50px; object-fit: cover"
                />
              </div>
            </ng-template>
          </ngx-datatable-column>

          <!-- Full Name -->
          <ngx-datatable-column
            name="Full Name"
            prop="full name"
            [flexGrow]="20"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div
                class="d-flex align-items-center cursor-pointer"
                (click)="userProfile(row.id)"
              >
                <small
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start goalngo-hover"
                  style="white-space: normal; word-break: break-word;"
                >
                  {{ row.firstName }} {{ row.lastName }}
                </small>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <!-- Age -->
          <ngx-datatable-column name="Age" prop="age" [flexGrow]="10">
            <ng-template ngx-datatable-cell-template let-row="row">
              <p
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
              >
                {{ row.age || "--" }}
              </p>
            </ng-template>
          </ngx-datatable-column>

          <!-- Country -->
          <ngx-datatable-column
            name="Country"
            prop="countryName"
            [flexGrow]="15"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <p
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
              >
                {{ row.countryName || "--" }}
              </p>
            </ng-template>
          </ngx-datatable-column>

          <!-- City -->
          <ngx-datatable-column
            name="City"
            prop="city"
            [flexGrow]="10"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <p
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
              >
                {{ row.city || "--" }}
              </p>
            </ng-template>
          </ngx-datatable-column>

          <!-- Phone Number -->
          <ngx-datatable-column
            name="Phone Number"
            prop="number"
            [flexGrow]="15"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <p
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
              >
                {{ row.number || "--" }}
              </p>
            </ng-template>
          </ngx-datatable-column>

          <!-- Nationality -->
          <ngx-datatable-column
            name="Nationality"
            prop="nationality"
            [flexGrow]="10"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <p
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
              >
                {{ row.nationality?.name || "--" }}
              </p>
            </ng-template>
          </ngx-datatable-column>

          <!-- Actions -->
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [flexGrow]="10"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
            >
              <div class="d-flex align-items-center">
                <div ngbDropdown container="body">
                  <a
                    ngbDropdownToggle
                    href="javascript:void(0);"
                    class="hide-arrow"
                    id="dropdownBrowserState"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i
                      data-feather="more-vertical"
                      class="text-primary cursor-pointer mr-50"
                    ></i>
                  </a>
                  <div
                    ngbDropdownMenu
                    class="dropdown-menu-right"
                    aria-labelledby="dropdownBrowserState"
                  >
                    <!-- <a [routerLink]="['/edit-users-list', row.id]" ngbDropdownItem
                      class="d-flex align-items-center"><i data-feather="edit" class="mr-50"></i>
                      Edit User</a> -->

                    <a
                      (click)="userProfile(row.id)"
                      ngbDropdownItem
                      class="d-flex align-items-center"
                      ><i data-feather="user" class="mr-50"></i>
                      Profile</a
                    >
                    <a
                    [routerLink]="['/pending-details', row.id]"
                      ngbDropdownItem
                      class="d-flex align-items-center"
                      ><i
                        data-feather="info"
                        class="mr-50"
                      ></i>
                      Details</a
                    >


                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>


</div>